import BaseService from './BaseService';
import { API_ENDPOINTS } from '../constants';
import apiConfig from '../config';

class AuthService {
  async sendCode(phone) {
    return BaseService.post(API_ENDPOINTS.AUTH.SEND_CODE, { phone });
  }

  async verifyCode(phone, code) {
    return BaseService.post(API_ENDPOINTS.AUTH.VERIFY_CODE, { phone, code });
  }

  async signup(phone, username, password) {
    const response = await BaseService.post(API_ENDPOINTS.AUTH.SIGNUP, { phone, username, password });
    const data = response.data || response;
    if (data.token) {
      apiConfig.setAuthToken(data.token);
      if (data.refreshToken) {
        apiConfig.setRefreshToken(data.refreshToken);
      }
      if (data.user) {
        apiConfig.setUserData(data.user);
      }
    }
    return data;
  }

  async createAdmin(adminData) {
    const response = await BaseService.post(API_ENDPOINTS.AUTH.CREATE_ADMIN, adminData);
    return response.data || response;
  }

  async login(phone, password) {
    const response = await BaseService.post(API_ENDPOINTS.AUTH.LOGIN, { phone, password });
    const data = response.data || response;
    if (data.token) {
      apiConfig.setAuthToken(data.token);
      if (data.refreshToken) {
        apiConfig.setRefreshToken(data.refreshToken);
      }
      if (data.user) {
        apiConfig.setUserData(data.user);
      }
    }
    return data;
  }

  async refreshToken() {
    const refreshToken = apiConfig.getRefreshToken();
    const response = await BaseService.post(API_ENDPOINTS.AUTH.REFRESH, { refreshToken });
    const data = response.data || response;
    if (data.token) {
      apiConfig.setAuthToken(data.token);
    }
    return data;
  }

  async logout() {
    const response = await BaseService.post(API_ENDPOINTS.AUTH.LOGOUT);
    apiConfig.clearTokens();
    apiConfig.clearUserData();
    return response;
  }

  async forgotPassword(phone) {
    return BaseService.post(API_ENDPOINTS.AUTH.FORGOT_PASSWORD, { phone });
  }

  async resetPassword(phone, code, password) {
    return BaseService.post(API_ENDPOINTS.AUTH.RESET_PASSWORD, { phone, code, password });
  }

  async getCurrentUser() {
    const response = await BaseService.get(API_ENDPOINTS.AUTH.ME);
    return response.data || response;
  }

  isAuthenticated() {
    return !!apiConfig.getAuthToken();
  }

  getUser() {
    return apiConfig.getUserData();
  }
}

const authService = new AuthService();
export default authService;
